import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'keywords/:url',
  async getComponent () {
    const {
      default: KeywordsContainer
    } = await import(/* webpackChunkName: "keywords-container" */ './containers/KeywordsContainer')
      .catch(handleChunkLoadError);
    return KeywordsContainer;
  },
  getData ({ context }) {
    return context.props;
  }
});
